import React, { useRef } from 'react';
import { Search } from 'lucide-react';
import PlaceAutocomplete from './PlaceAutocomplete';

function LandingPage({ onLocationSubmit }) {
  const placeAutocompleteRef = useRef(null);

  const handlePlaceSelect = (place) => {
    const address = place.formatted_address || place.name;
    if (address && address.trim()) {
      onLocationSubmit(address);
    }
  };
  
  const handleFormSubmit = (e) => {
    e.preventDefault();
    const gmpAutocomplete = placeAutocompleteRef.current;
    // Fallback for when user presses enter without selecting a prediction
    if (gmpAutocomplete && gmpAutocomplete.shadowRoot) {
      const input = gmpAutocomplete.shadowRoot.querySelector('input');
      if (input && input.value.trim()) {
        onLocationSubmit(input.value);
      }
    }
  };

  return (
    <div className="landing-container">
      <div className="landing-content">
        <img src="https://cdn.prod.website-files.com/5d55f1425cb6b7a18aa77528/67b647121d0a27157eade3dd_logo.svg" alt="AirGarage Logo" className="landing-logo" />
        <h1 className="text-3xl font-bold mb-2">Parking Revenue Calculator</h1>
        <p className="text-lg text-gray-600 mb-8">Enter a lot name or address to see how much more you could be earning.</p>
        <form onSubmit={handleFormSubmit} className="w-full max-w-2xl">
          <div className="relative autocomplete-container">
            <PlaceAutocomplete ref={placeAutocompleteRef} onPlaceSelect={handlePlaceSelect} />
            <button type="submit" className="landing-button">
              <Search size={24} />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LandingPage; 